export default __webpack_public_path__ + "static/media/yaksha.f77cd2f1.png";